import { Controller } from '@hotwired/stimulus';
import FormWriter from '../lib/form_writer';

/**
 * Marks the dashboard form and exposes its writes to code holding a controller
 * instance. The writes themselves live in FormWriter so that a host app's
 * extension controllers, which run in a separate Stimulus application and
 * therefore cannot resolve this instance, write the form the same way.
 */
export default class ChartingFormController extends Controller {
  static targets = ['visual', 'filter', 'pagination', 'sort'];

  get writer() {
    return new FormWriter(this.element);
  }

  setVisual(namespace, key, value) {
    this.writer.setVisual(namespace, key, value);
  }

  setSort(namespace, member, direction) {
    this.writer.setSort(namespace, member, direction);
  }

  setPagination(namespace, key, page, limit) {
    this.writer.setPagination(namespace, key, page, limit);
  }

  setFilter(namespace, member, operator, value) {
    this.writer.setFilter(namespace, member, operator, value);
  }

  removeFilter(namespace, member) {
    this.writer.removeFilter(namespace, member);
  }

  submit() {
    this.writer.submit();
  }
}
